exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#StdAttribute[data-v-5f5c9ad1] .el-input-number.is-without-controls .el-input__inner{text-align:left}", ""]);

// exports
